import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";



@Component({
  selector: 'app-search-redirect',
  templateUrl: './search-redirect.component.html',
  styleUrls: ['./search-redirect.component.scss']
})
export class SearchRedirectComponent implements OnInit {

  public searchText: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.searchText = '';
  }

  ngOnInit() {
    if (typeof this.activatedRoute !== 'undefined'
      && typeof this.activatedRoute.params !== 'undefined') {
      this.activatedRoute.params.subscribe(params => {
        if (params['text']) {
          this.searchText = params['text'];
        }
      });
    }
  }

  onSubmit() {
    this.router.navigate(['/rulebook/search', this.searchText]);
  }

}
